<template>
  <div id="app">
    <Logo/>
    <RecordOfSupport
      :gotoSlide="gotoSlide"
      :isVisibleSlide="isVisibleSlide"
      :analytics="analytics"
    />
    <Thanks :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <TellYourMP :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <MeetAsk :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <MeetYourMP :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <WillYouShare :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <Share :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
    <Donate :isVisibleSlide="isVisibleSlide" :analytics="analytics"/>
  </div>
</template>

<script>
import axios from "axios";
import Logo from "./components/Logo.vue";
import RecordOfSupport from "./slides/RecordOfSupport.vue";
import Thanks from "./slides/Thanks.vue";
import TellYourMP from "./slides/TellYourMP.vue";
import MeetYourMP from "./slides/MeetYourMP.vue";
import Share from "./slides/Share.vue";
import Donate from "./slides/Donate.vue";
import MeetAsk from "./slides/MeetAsk.vue";
import WillYouShare from "./slides/WillYouShare.vue";

export default {
  name: "app",
  components: {
    Logo,
    RecordOfSupport,
    TellYourMP,
    MeetYourMP,
    Share,
    Thanks,
    WillYouShare,
    MeetAsk,
    Donate
  },
  mounted() {
    window.state = this.$store.state;
    axios
      .get(
        "https://action.dignityindying.org.uk/page/widget/404506?token=e936dd7e-089e-4376-a11b-80bfd5bdb00e"
      )
      .then(response => {
        // handle success
        console.log(response.data.data.rows[0].columns[0].value);
        this.$store.commit(
          "setSignups",
          response.data.data.rows[0].columns[0].value
        );
      })
      .catch(error => {
        // handle error
        console.log(error);
      });
  },
  methods: {
    gotoSlide(slide) {
      if (!this.isVisibleSlide(slide)) {
        this.$store.state.visibleSlides.push(slide);
      }
      setTimeout(() => this.$scrollTo("#" + slide, "600"), 100);
    },
    isVisibleSlide(slide) {
      return this.$store.state.visibleSlides.indexOf(slide) !== -1;
    },
    analytics(action, label) {
      console.log(action + " - " + label);
      window.dataLayer.push({
        event: "event",
        eventCategory: "did-record-of-support",
        eventAction: action,
        eventLabel: label
      });
      // eslint-disable-next-line
      ga(function() {
        // eslint-disable-next-line
        var trackers = ga.getAll();
        trackers.forEach(function(tracker) {
          var nameOfGa = tracker.get("name");
          // eslint-disable-next-line
          ga(
            nameOfGa + ".send",
            "event",
            "did-record-of-support",
            action,
            label
          );
        });
      });
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Sabon";
  font-weight: normal;
  font-style: normal;
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_0_0.eot?v=1551866577000);
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_0_0.eot?v=1551866577000?#iefix)
      format("embedded-opentype"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_0_0.woff2?v=1551866615000)
      format("woff2"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_0_0.woff?v=1551866661000)
      format("woff"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_0_0.ttf?v=1551866703000)
      format("truetype");
}

@font-face {
  font-family: "Sabon";
  font-weight: bold;
  font-style: normal;
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_1_0.eot?v=1551866751000);
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_1_0.eot?v=1551866751000?#iefix)
      format("embedded-opentype"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_1_0.woff2?v=1551866788000)
      format("woff2"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_1_0.woff?v=1551866819000)
      format("woff"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_1_0.ttf?v=1551866855000)
      format("truetype");
}

@font-face {
  font-family: "Sabon";
  font-weight: bold;
  font-style: italic;
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_2_0.eot?v=1551866908000);
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_2_0.eot?v=1551866908000?#iefix)
      format("embedded-opentype"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_2_0.woff2?v=1551866965000)
      format("woff2"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_2_0.woff?v=1551867016000)
      format("woff"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_2_0.ttf?v=1551867039000)
      format("truetype");
}

@font-face {
  font-family: "Sabon";
  font-weight: normal;
  font-style: italic;
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_3_0.eot?v=1551867062000);
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_3_0.eot?v=1551867062000?#iefix)
      format("embedded-opentype"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_3_0.woff2?v=1551867087000)
      format("woff2"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_3_0.woff?v=1551867115000)
      format("woff"),
    url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/33B933_3_0.ttf?v=1551867151000)
      format("truetype");
}

@font-face {
  font-family: "Interstate";
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/intlt___.ttf?v=1551867182000)
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Interstate";
  src: url(https://secure.dignityindying.org.uk/sites/dignityindying/themes/big_pic_theme/css/fonts/intlti___.ttf)
    format("truetype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Interstate";
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/intbd___.ttf?v=1551867219000)
    format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Interstate";
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/intbdi__.ttf?v=1551867259000)
    format("truetype");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Interstate Black";
  src: url(https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/Interstate-Black.ttf?v=1551867289000)
    format("truetype");
  font-weight: bold;
  font-style: normal;
}
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "Interstate Black", sans-serif;
}

h1 {
  color: #be1851;
  text-transform: uppercase;

  margin-top: 0;
  font-size: 35px;
  line-height: 1.27;
  letter-spacing: 0.4px;

  @media (max-width: 767px) {
    font-size: 30px;
  }
}
h2 {
  color: #be1851;
  margin-top: 0;
  font-size: 28px;
  line-height: 1.27;
  letter-spacing: 0.4px;
  @media (max-width: 767px) {
    font-size: 26px;
  }
}

p {
  color: #303030;
  font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
  font-size: 20px;
}

.slide {
  min-height: 100vh;
  background-size: cover;
  background-image: url("https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/Campaignion-Background-Image-1.jpg?v=1553617637000");
  background-repeat: no-repeat;
  padding: 50px 30px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-attachment: fixed;

  @media (max-width: 767px) {
    padding: 50px 15px;
  }
  .container {
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 50px;
    border-radius: 8px;
    text-align: center;
    width: 900px;
    max-width: 100%;
    height: 100%;

    p {
      font-size: 24px;
      line-height: 1.3;
      @media (max-width: 767px) {
        font-size: 20px;
      }
    }

    @media (max-width: 767px) {
      padding: 30px 15px;
    }
  }
  &.narrow {
    .slide_inner {
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 1160px;
      margin: 0 auto;
      .left {
        width: 50%;
        @media (max-width: 767px) {
          display: none;
        }
      }

      .container {
        width: 50%;
        text-align: left;
        @media (max-width: 767px) {
          width: 100%;
        }
        p {
          font-size: 20px;
          @media (max-width: 767px) {
            font-size: 18px;
          }
        }
      }
    }
  }
}

button,
a.button {
  outline: none;
  border: none;
  padding: 15px 15px;
  width: auto;
  font-size: 20px;
  border-radius: 4px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
  color: white;
  margin: 0 10px;
  cursor: pointer;
  font-weight: bold;
  text-transform: uppercase;
  font-family: "Interstate Black", sans-serif;
  min-width: 150px;
  text-decoration: none;
  @media (max-width: 767px) {
    margin: 5px;
  }
  &.pink {
    background-color: #d51b5b;
    @media only screen and (max-width: 767px) {
      display: block;
      width: 100%;
    }
  }
  &.grey {
    background-color: #7f7f7f;
    @media only screen and (max-width: 767px) {
      display: block;
      width: 100%;
    }
  }
  &.facebook {
    background-color: #3b5998;
    @media only screen and (max-width: 767px) {
      display: block;
      width: 100%;
    }
  }
  &.whatsapp {
    background-color: #25d366;
    display: none;
    @media only screen and (max-width: 767px) {
      display: block;
      width: 100%;
    }
  }
  &:hover {
    background-color: #000;
    border-color: #000;
    color: #fff;
  }
}

form {
  .input-group {
    margin-bottom: 10px;
    .validation-error {
      font-size: 12px;
      color: red;
      margin: 5px 0 0;
      padding: 0;
    }

    &.inline {
      display: flex;
      flex-wrap: wrap;
      label {
        width: 100%;
      }

      .radio {
        margin: 5px 0;
        display: block;
        cursor: pointer;
        width: 50%;
        input {
          display: none;
          & + span {
            line-height: 22px;
            height: 22px;
            padding-left: 22px;
            display: block;
            position: relative;
            &:not(:empty) {
              padding-left: 22px + 8;
            }
            &:before,
            &:after {
              content: "";
              width: 22px;
              height: 22px;
              display: block;
              border-radius: 50%;
              left: 0;
              top: 0;
              position: absolute;
            }
            &:before {
              background: #565656;
              transition: background 0.2s ease,
                transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 2);
            }
            &:after {
              background: #fff;
              transform: scale(0.78);
              transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.4);
            }
          }
          &:checked + span {
            &:before {
              transform: scale(1.04);
              background: #d51b5b;
            }
            &:after {
              transform: scale(0.4);
              transition: transform 0.3s ease;
            }
          }
        }
        &:hover {
          input {
            & + span {
              &:before {
                transform: scale(1.14);
              }
              &:after {
                transform: scale(0.78);
              }
            }
            &:checked + span {
              &:after {
                transform: scale(0.4);
              }
            }
          }
        }
      }
    }
  }
  label {
    font-weight: bold;
    font-style: normal;
    display: block;
    color: #303030;
    font-size: 20px;
    font-family: "Interstate", "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 6px 0;
    &.small {
      font-size: 14px;
      font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
      line-height: 1.5;
      color: #303030;
    }
    .pink {
      color: #d51b5b;
    }
  }
  input,
  textarea {
    width: 100%;
    border-radius: 0;
    border: 2px solid #565656;
    padding: 14px 20px;
    color: #303030;
    font-size: 20px;
    font-family: "Interstate", "Helvetica Neue", Helvetica, Arial, sans-serif;
    &.invalid {
      border: 2px solid red;
    }
    &:focus {
      border-color: #4087c4;
      color: #303030;
      outline: none;
    }
  }
  button {
    display: block;
    background-color: #d51b5b;
    color: #ffffff;
    font-size: 35px;
    border: none;
    width: 100%;
    text-align: center;
    padding: 0.75rem 1.5rem;
    text-transform: uppercase;
    font-family: "Interstate Black", sans-serif;
    transition: background-color 0.2s linear;
    cursor: pointer;
    margin: 0;
    @media (max-width: 767px) {
      font-size: 26px;
    }
    &:hover {
      background-color: #000;
      border-color: #000;
      color: #fff;
    }
    &:focus {
      outline: 0;
    }
  }
}
</style>
